"use client";
import { PageDrawer } from "@layer/ui/patterns";
import { type PropsWithChildren, useState } from "react";
import type { ClientDTO } from "@/api/types/clients.types";
import { CreateClientForm } from "../forms/create-client-form";

export type CreateNewClientDrawerTriggerParams = PropsWithChildren & {
	open?: boolean;
	onOpenChange?: (open: boolean) => void;
	client?: ClientDTO;
	title?: string;
};

export const CreateNewClientDrawerTrigger = ({
	children,
	open: controlledOpen,
	onOpenChange: controlledOnOpenChange,
	client,
	title = "Create new client",
}: CreateNewClientDrawerTriggerParams) => {
	const [internalOpen, setInternalOpen] = useState(false);
	const isControlled = controlledOpen !== undefined;
	const open = isControlled ? controlledOpen : internalOpen;
	const setOpen = isControlled
		? (controlledOnOpenChange ?? (() => {}))
		: setInternalOpen;

	return (
		<PageDrawer
			open={open}
			onOpenChange={setOpen}
			title={title}
			width="w-1/2"
			trigger={children ?? <span />}
			content={
				<CreateClientForm
					client={client}
					onClose={() => setOpen(false)}
				/>
			}
		/>
	);
};

export default CreateNewClientDrawerTrigger;
